import styled from 'styled-components';
import Button from '../../Button/button';
import BREAKPOINTS from '../../../style/breakpoints';

export const CloseButtonContainer = styled(Button)`
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding-left: 12px;
  padding-right: 12px;
  position: absolute;
  right: 1px;
  top: 1px;
  z-index: 1;

  &:hover {
    background-color: rgba(0, 0, 0, 1);
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 137, 255, 0.65);
    outline: none;
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    right: -42px;
    top: -42px;
  }
`;
